// Central catalog for upgrades. Ordered from earliest to most advanced era.
// Each upgrade defines: id, name, description, baseCost, production (Berry/s),
// and eraKey (used by WheelSVG to render the era-specific wheel).
export const UPGRADES = [
  {
    id: "log",
    name: "Rolling Log",
    description: "Before the wheel, logs allowed heavy loads to be moved.",
    baseCost: 25,
    production: 1,
    eraKey: "log",
  },
  {
    id: "wood_wheel",
    name: "First Wooden Wheel",
    description: "The first solid wheels used by ancient civilizations.",
    baseCost: 100,
    production: 5,
    eraKey: "wood_wheel",
  },
  {
    id: "spoked_wheel",
    name: "Spoked Wheel",
    description: "Spokes reduce weight and drastically improve speed.",
    baseCost: 500,
    production: 20,
    eraKey: "spoked_wheel",
  },
  {
    id: "war_chariot",
    name: "War Chariot",
    description: "Chariots revolutionize transport and warfare.",
    baseCost: 2500,
    production: 100,
    eraKey: "war_chariot",
  },
  {
    id: "roman_chariot",
    name: "Roman Chariot",
    description: "The wheel drives the trade of the Roman Empire.",
    baseCost: 10000,
    production: 500,
    eraKey: "roman_chariot",
  },
  {
    id: "medieval_wagon",
    name: "Medieval Wagon",
    description: "Agricultural expansion boosts wheel adoption.",
    baseCost: 50000,
    production: 2000,
    eraKey: "medieval_wagon",
  },
  {
    id: "industrial",
    name: "Industrial Revolution",
    description: "Mechanization sends production through the roof.",
    baseCost: 250000,
    production: 10000,
    eraKey: "industrial",
  },
  {
    id: "locomotive",
    name: "Steam Locomotive",
    description: "Wheels power the modern railway.",
    baseCost: 1000000,
    production: 50000,
    eraKey: "locomotive",
  },
  {
    id: "bicycle",
    name: "Modern Bicycle",
    description: "Personal mobility transforms the world.",
    baseCost: 5000000,
    production: 250000,
    eraKey: "bicycle",
  },
  {
    id: "automobile",
    name: "Automobile",
    description: "Industrial production makes the wheel an everyday object.",
    baseCost: 25000000,
    production: 1000000,
    eraKey: "automobile",
  },
  {
    id: "f1",
    name: "Formula 1",
    description: "Engineering pushes the wheel to peak performance.",
    baseCost: 100000000,
    production: 5000000,
    eraKey: "f1",
  },
  {
    id: "space",
    name: "Space Exploration",
    description: "Wheels reach other planets aboard rovers.",
    baseCost: 500000000,
    production: 25000000,
    eraKey: "space",
  },
  {
    id: "community",
    name: "Cosmic Community",
    description: "Join the BendyWheels Discord and unlock the ultimate era.",
    baseCost: 10000000000,
    production: 500000000,
    eraKey: "community",
    unlockDiscord: true,
  },
];

export const COST_MULTIPLIER = 1.15;
export const SAVE_INTERVAL_MS = 3000;
export const TICK_MS = 100; // 10 ticks per second for smooth counter
export const STORAGE_KEY = "bendywheels_save_v1";

// Return the current era key based on the highest upgrade level owned (>=1).
export const getCurrentEraKey = (upgrades) => {
  for (let i = UPGRADES.length - 1; i >= 0; i -= 1) {
    if ((upgrades[UPGRADES[i].id] || 0) >= 1) return UPGRADES[i].eraKey;
  }
  return "hand"; // starting era before any upgrade
};

// Human-readable name for the "hand" starting era.
export const EMPTY_HANDS_NAME = "Empty Hands";

export const getUpgradeCost = (baseCost, count) =>
  Math.ceil(baseCost * Math.pow(COST_MULTIPLIER, count));

export const getTotalProduction = (upgrades) =>
  UPGRADES.reduce((sum, u) => sum + (upgrades[u.id] || 0) * u.production, 0);
